var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main bg--light"},[(_vm.isAuthenticated)?[_c('Navbar'),_c('Sidebar')]:_vm._e(),_c('router-view',{key:_vm.$route.fullPath,staticClass:"bg--light"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }